export default "__VITE_ASSET__CUXpkV4W__"